import { render, staticRenderFns } from "./tickets.vue?vue&type=template&id=30fe0c5d&"
import script from "./tickets.vue?vue&type=script&lang=js&"
export * from "./tickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports